export default "__VITE_ASSET__BUfWaRfJ__"